import * as React from 'react';
import {Link, useParams} from 'react-router-dom';
import {useCallback, useEffect, useState} from "react";
import {deleteCharge, getCharge} from "../../../api";
import {useHistory} from "react-router";


const ViewCharge: React.FunctionComponent = () => {

    const {clientId, chargeId} = useParams();
    const [amount, setAmount] = useState("");
    const [createdAt, setCreatedAt] = useState("");
    const [description, setDescription] = useState("");
    const [doSearchRedirect, setDoSearchRedirect] = useState(false);

    const history = useHistory();

    useEffect(() => {
        if (doSearchRedirect) {
            history.push({
                pathname: "/m/clients/view/" + clientId
            });
        }
    }, [doSearchRedirect, history,clientId]);

    const load = useCallback(() => {
        getCharge(clientId, chargeId)
            .then((c) => {
                setAmount("" + c.amount);
                setCreatedAt(c.chargeDate);
                setDescription(c.description);
            });
    }, [clientId, chargeId])

    useEffect(() => {
        load();
    }, [load]);

    const doDelete = () => {
        deleteCharge(clientId, chargeId)
            .then((r) => {
                if (r.ok) {
                    setDoSearchRedirect(true);
                }
            })
    }

    return (<>
        <form>
            <div className={"row"}>
                <div className={"col-lg-12 mb-3 "}>
                    <h2>Charge</h2>
                </div>

                <div className={"col-lg-12 mb-3 "}>
                    <h6>Item Details</h6>
                </div>
                <div className={"col-lg-12 mb-3 "}>

                    <div className="form-row align-items-center">
                        <div className="col-sm-3 my-1">
                            <label htmlFor="inputEmail4">Item</label>
                            <select disabled={true} id="inputState" className="form-control"
                                    value={description} onChange={(e) => setDescription(e.target.value)}>
                                <option value={""} disabled={true}>Choose...</option>
                                <option value={"Assessment"}>Assessment</option>
                                <option value={"Therapy session"}>Therapy session</option>
                                <option value={"Other"}>Other</option>
                            </select>
                        </div>
                        <div className="col-sm-2 my-1">
                            <label htmlFor="inputEmail4">Amount</label>
                            <input disabled={true} type="number" className="form-control" id="inlineFormInputName"
                                   value={amount} onChange={(e) => setAmount(e.target.value)}/>
                        </div>
                        <div className="col-sm-3 my-1">
                            <label htmlFor="inputEmail4">Transaction Date</label>
                            <input disabled={true} type="date" className="form-control" id="inlineFormInputName"
                                   value={createdAt} onChange={(e) => setCreatedAt(e.target.value)}/>
                        </div>
                    </div>
                </div>

                <div className={"col-lg-12 mb-3 "}>
                    <Link to={"/m/clients/view/" + clientId}>
                        <button type={"submit"} className={"btn btn-primary mr-3"}>Back</button>
                    </Link>
                    <button type={"submit"} className={"btn btn-danger"}
                            onClick={(e) => {
                                e.preventDefault();
                                doDelete();
                            }}>Delete
                    </button>
                </div>

            </div>
        </form>
    </>);
};

export default ViewCharge;